import { useEffect } from 'react';

export const useScrollToOffset = ({ ref, trigger = false, offset = 0, behavior = 'smooth' }) => {
  useEffect(() => {
    if (!trigger || !ref?.current) return;

    let node = ref.current.parentElement;

    while (node && node !== document.body) {
      const style = window.getComputedStyle(node);
      const isScrollable =
        node.scrollHeight > node.clientHeight &&
        (style.overflowY === 'auto' || style.overflowY === 'scroll');

      if (isScrollable) {
        const elementTop = ref.current.getBoundingClientRect().top;
        const parentTop = node.getBoundingClientRect().top;
        const relativeTop = elementTop - parentTop;

        node.scrollTo({
          top: node.scrollTop + relativeTop - offset,
          behavior,
        });
        break;
      }

      node = node.parentElement;
    }
  }, [trigger, ref, offset, behavior]);
};

export default useScrollToOffset;
